// v1 without valiadation
// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const validationSchema = Yup.object({
//   holder_name: Yup.string().required("Account Holder Name is required"),
//   acc_no: Yup.string().required("Account No is required"),
//   bank_name: Yup.string().required("Bank Name is required"),
//   branch_name: Yup.string().required("Branch Name is required"),
//   ifsc_code: Yup.string().required("IFSC Code is required"),
//   refund_front_sheet: Yup.mixed()
//     .required("Refund Front Sheet is required")
//     .test("fileExists", "Refund Front Sheet is required", (value) => value != null)
//     .test(
//       "fileSize",
//       "File size must be less than 2MB",
//       (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//     ),
// });

// function RefundBankSection({ refundBank, setRefundBank, activeTab, setActiveTab }) {
//   const { t } = useTranslation();
//   const [showOtherRelation, setShowOtherRelation] = useState(false);

//   const formik = useFormik({
//     initialValues: refundBank,
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setRefundBank(values);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChange = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box component="form" onSubmit={formik.handleSubmit} noValidate>
//           <Stack spacing={3}>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.accountHolderName")}
//                 name="holder_name"
//                 value={formik.values.holder_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.holder_name && Boolean(formik.errors.holder_name)}
//                 helperText={formik.touched.holder_name && formik.errors.holder_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.accountNo")}
//                 name="acc_no"
//                 value={formik.values.acc_no}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.acc_no && Boolean(formik.errors.acc_no)}
//                 helperText={formik.touched.acc_no && formik.errors.acc_no}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.bankName")}
//                 name="bank_name"
//                 value={formik.values.bank_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
//                 helperText={formik.touched.bank_name && formik.errors.bank_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.branchName")}
//                 name="branch_name"
//                 value={formik.values.branch_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.branch_name && Boolean(formik.errors.branch_name)}
//                 helperText={formik.touched.branch_name && formik.errors.branch_name}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.ifscCode")}
//                 name="ifsc_code"
//                 value={formik.values.ifsc_code}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.ifsc_code && Boolean(formik.errors.ifsc_code)}
//                 helperText={formik.touched.ifsc_code && formik.errors.ifsc_code}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
//               <UploadWithLabel
//                 label={t("refundBank.labels.uploadPassbook")}
//                 name="refund_front_sheet"
//                 onChange={(e) => handleFileChange(e, "refund_front_sheet")}
//                 file={formik.values.refund_front_sheet}
//                 error={formik.touched.refund_front_sheet && Boolean(formik.errors.refund_front_sheet)}
//                 helperText={formik.touched.refund_front_sheet && formik.errors.refund_front_sheet}
//               />
//             </Box>
//             <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//               <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                 {t("refundBank.buttons.back")}
//               </Button>
//               <Button type="submit" variant="contained">
//                 {t("refundBank.buttons.next")}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// }

// export default RefundBankSection;


// v2 with validation
// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const validationSchema = Yup.object({
//   holder_name: Yup.string().required("Account Holder Name is required"),
//   acc_no: Yup.string()
//     .matches(/^\d{9,18}$/, "Account number must be 9-18 digits")
//     .required("Account No is required"),
//   bank_name: Yup.string().required("Bank Name is required"),
//   branch_name: Yup.string().required("Branch Name is required"),
//   ifsc_code: Yup.string()
//     .matches(
//       /^[A-Z]{4}0[A-Z0-9]{6}$/,
//       "IFSC must be 11 characters (4 letters + 0 + 6 alphanumeric)"
//     )
//     .required("IFSC Code is required"),
//   refund_front_sheet: Yup.mixed()
//     .required("Refund Front Sheet is required")
//     .test("fileExists", "Refund Front Sheet is required", (value) => value != null)
//     .test(
//       "fileType",
//       "Only PDF files are allowed",
//       (value) =>
//         !value || (value.type && value.type === "application/pdf")
//     )
//     .test(
//       "fileSize",
//       "File size must be less than 2MB",
//       (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//     ),
// });

// function RefundBankSection({ refundBank, setRefundBank, activeTab, setActiveTab }) {
//   const { t } = useTranslation();
//   const [showOtherRelation, setShowOtherRelation] = useState(false);

//   const formik = useFormik({
//     initialValues: refundBank,
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setRefundBank(values);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChange = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box component="form" onSubmit={formik.handleSubmit} noValidate>
//           <Stack spacing={3}>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.accountHolderName")}
//                 name="holder_name"
//                 value={formik.values.holder_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.holder_name && Boolean(formik.errors.holder_name)}
//                 helperText={formik.touched.holder_name && formik.errors.holder_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.accountNo")}
//                 name="acc_no"
//                 value={formik.values.acc_no}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.acc_no && Boolean(formik.errors.acc_no)}
//                 helperText={formik.touched.acc_no && formik.errors.acc_no}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.bankName")}
//                 name="bank_name"
//                 value={formik.values.bank_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
//                 helperText={formik.touched.bank_name && formik.errors.bank_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.branchName")}
//                 name="branch_name"
//                 value={formik.values.branch_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.branch_name && Boolean(formik.errors.branch_name)}
//                 helperText={formik.touched.branch_name && formik.errors.branch_name}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.ifscCode")}
//                 name="ifsc_code"
//                 value={formik.values.ifsc_code}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.ifsc_code && Boolean(formik.errors.ifsc_code)}
//                 helperText={formik.touched.ifsc_code && formik.errors.ifsc_code}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
//               <UploadWithLabel
//                 label={t("refundBank.labels.uploadPassbook")}
//                 name="refund_front_sheet"
//                 onChange={(e) => handleFileChange(e, "refund_front_sheet")}
//                 file={formik.values.refund_front_sheet}
//                 error={formik.touched.refund_front_sheet && Boolean(formik.errors.refund_front_sheet)}
//                 helperText={formik.touched.refund_front_sheet && formik.errors.refund_front_sheet}
//               />
//             </Box>
//             <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//               <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                 {t("refundBank.buttons.back")}
//               </Button>
//               <Button type="submit" variant="contained">
//                 {t("refundBank.buttons.next")}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// }

// export default RefundBankSection;



// import React, { useState } from "react";
// import {
//   Box,
//   Typography,
//   TextField,
//   Button,
//   Container,
//   Paper,
//   Stack,
// } from "@mui/material";
// import TwoFieldRow from "./twoFieldsRow";
// import UploadWithLabel from "./uploadWithLable";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import { useTranslation } from "react-i18next";

// const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

// const validationSchema = Yup.object({
//   holder_name: Yup.string().required("Account Holder Name is required"),
//   acc_no: Yup.string()
//     .matches(/^\d{9,18}$/, "Account number must be 9-18 digits")
//     .required("Account No is required"),
//   bank_name: Yup.string().required("Bank Name is required"),
//   branch_name: Yup.string().required("Branch Name is required"),
//   ifsc_code: Yup.string()
//     .matches(
//       /^[A-Z]{4}0[A-Z0-9]{6}$/,
//       "IFSC must be 11 characters (4 letters + 0 + 6 alphanumeric)"
//     )
//     .required("IFSC Code is required"),
//   refund_front_sheet: Yup.mixed()
//     .required("Refund Front Sheet is required")
//     .test("fileExists", "Refund Front Sheet is required", (value) => value != null)
//     .test(
//       "fileType",
//       "Only PDF files are allowed",
//       (value) =>
//         !value || (value.type && value.type === "application/pdf")
//     )
//     .test(
//       "fileSize",
//       "File size must be less than 2MB",
//       (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
//     ),
// });

// function RefundBankSection({ refundBank, setRefundBank, activeTab, setActiveTab }) {
//   const { t } = useTranslation();
//   const [showOtherRelation, setShowOtherRelation] = useState(false);

//   const formik = useFormik({
//     initialValues: refundBank,
//     validationSchema,
//     enableReinitialize: true,
//     onSubmit: (values) => {
//       setRefundBank(values);
//       setActiveTab(activeTab + 1);
//     },
//   });

//   const handleFileChange = (e, fieldName) => {
//     const file = e.currentTarget.files[0] || null;
//     formik.setFieldValue(fieldName, file);
//     formik.setFieldTouched(fieldName, true);
//   };

//   return (
//     <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
//       <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
//         <Box component="form" onSubmit={formik.handleSubmit} noValidate>
//           <Stack spacing={3}>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.accountHolderName")}
//                 name="holder_name"
//                 value={formik.values.holder_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.holder_name && Boolean(formik.errors.holder_name)}
//                 helperText={formik.touched.holder_name && formik.errors.holder_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.accountNo")}
//                 name="acc_no"
//                 value={formik.values.acc_no}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.acc_no && Boolean(formik.errors.acc_no)}
//                 helperText={formik.touched.acc_no && formik.errors.acc_no}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.bankName")}
//                 name="bank_name"
//                 value={formik.values.bank_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
//                 helperText={formik.touched.bank_name && formik.errors.bank_name}
//                 fullWidth
//               />
//               <TextField
//                 label={t("refundBank.labels.branchName")}
//                 name="branch_name"
//                 value={formik.values.branch_name}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.branch_name && Boolean(formik.errors.branch_name)}
//                 helperText={formik.touched.branch_name && formik.errors.branch_name}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <TwoFieldRow>
//               <TextField
//                 label={t("refundBank.labels.ifscCode")}
//                 name="ifsc_code"
//                 value={formik.values.ifsc_code}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={formik.touched.ifsc_code && Boolean(formik.errors.ifsc_code)}
//                 helperText={formik.touched.ifsc_code && formik.errors.ifsc_code}
//                 fullWidth
//               />
//             </TwoFieldRow>
//             <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
//               <UploadWithLabel
//                 label={t("refundBank.labels.uploadPassbook")}
//                 name="refund_front_sheet"
//                 onChange={(e) => handleFileChange(e, "refund_front_sheet")}
//                 file={formik.values.refund_front_sheet}
//                 error={formik.touched.refund_front_sheet && Boolean(formik.errors.refund_front_sheet)}
//                 helperText={formik.touched.refund_front_sheet && formik.errors.refund_front_sheet}
//               />
//               {formik.touched.refund_front_sheet && formik.errors.refund_front_sheet && (
//                 <Typography color="error" variant="caption" sx={{ ml: 2 }}>
//                   {formik.errors.refund_front_sheet}
//                 </Typography>
//               )}
//             </Box>
//             <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
//               <Button variant="outlined" onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}>
//                 {t("refundBank.buttons.back")}
//               </Button>
//               <Button 
//                 type="submit" 
//                 variant="contained"
//                 sx={{
//                   "&.Mui-disabled": {
//                     backgroundColor: "rgba(25, 118, 210, 0.6)",
//                     color: "rgba(255, 255, 255, 0.9)",
//                     cursor: "not-allowed",
//                   },
//                 }}
//               >
//                 {t("refundBank.buttons.next")}
//               </Button>
//             </Box>
//           </Stack>
//         </Box>
//       </Paper>
//     </Container>
//   );
// }

// export default RefundBankSection;



// kdjfjdsjfjd
import React, { useState, useEffect, useCallback, useRef } from "react";
import {
  Box,
  Typography,
  TextField,
  Button,
  Container,
  Paper,
  Stack,
  Autocomplete,
  CircularProgress,
  Alert,
  Collapse,
  IconButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import TwoFieldRow from "./twoFieldsRow";
import UploadWithLabel from "./uploadWithLable";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import debounce from "lodash/debounce";

const MAX_FILE_SIZE = 2 * 1024 * 1024; // 2MB

const validationSchema = Yup.object({
  // holder_name: Yup.string().required("Account Holder Name is required"),
  holder_name: Yup.string()
    .required("Account Holder Name is required")
    .trim()
    .matches(/^[\p{L}\s'-]+$/u, "Account Holder Name must contain only letters and spaces"),
  acc_no: Yup.string()
    .matches(/^\d{9,18}$/, "Account number must be 9-18 digits")
    .required("Account No is required"),
  bank_name: Yup.string().required("Bank Name is required"),
  branch_name: Yup.string().required("Branch Name is required"),
  ifsc_code: Yup.string()
    .matches(
      /^[A-Z]{4}0[A-Z0-9]{6}$/,
      "IFSC must be 11 characters (4 letters + 0 + 6 alphanumeric)"
    )
    .required("IFSC Code is required"),
  refund_front_sheet: Yup.mixed()
    .required("Refund Front Sheet is required")
    .test("fileExists", "Refund Front Sheet is required", (value) => value != null)
    .test(
      "fileType",
      "Only PDF files are allowed",
      (value) => !value || (value.type && value.type === "application/pdf")
    )
    .test(
      "fileSize",
      "File size must be less than 2MB",
      (value) => !value || (value.size && value.size <= MAX_FILE_SIZE)
    ),
});

function RefundBankSection({ refundBank, setRefundBank, activeTab, setActiveTab }) {
  const { t } = useTranslation();
  const [showManualFields, setShowManualFields] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isVerifyingIFSC, setIsVerifyingIFSC] = useState(false);
  const [apiError, setApiError] = useState("");
  const [recentIFSCs, setRecentIFSCs] = useState([]);
  const ifscInputRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      holder_name: refundBank?.holder_name || "",
      acc_no: refundBank?.acc_no || "",
      bank_name: refundBank?.bank_name || "",
      branch_name: refundBank?.branch_name || "",
      ifsc_code: refundBank?.ifsc_code || "",
      refund_front_sheet: refundBank?.refund_front_sheet || null,
    },
    validationSchema,
    validateOnMount: true,
    validateOnChange: true,
    validateOnBlur: true,
    enableReinitialize: true,
    onSubmit: (values) => {
      setRefundBank(values);
      setActiveTab(activeTab + 1);
    },
  });

  // ✅ FETCH BANK DETAILS FROM RAZORPAY IFSC API
  const fetchBankFromIFSC = async (ifscCode, isAutoFetch = false) => {
    if (!ifscCode || ifscCode.length !== 11) return false;
    
    const ifscUpper = ifscCode.toUpperCase();
    
    // Validate IFSC format
    const ifscPattern = /^[A-Z]{4}0[A-Z0-9]{6}$/;
    if (!ifscPattern.test(ifscUpper)) {
      formik.setFieldError("ifsc_code", "Invalid IFSC format. Must be 11 characters: 4 letters + 0 + 6 alphanumeric");
      return false;
    }
    
    if (!isAutoFetch) {
      setIsVerifyingIFSC(true);
    }
    setIsLoading(true);
    setApiError("");
    
    try {
      const response = await fetch(`https://ifsc.razorpay.com/${ifscUpper}`);
      
      if (response.ok) {
        const data = await response.json();
        
        if (data.IFSC && data.BANK) {
          // Update formik values
          formik.setFieldValue("bank_name", data.BANK);
          formik.setFieldValue("branch_name", data.BRANCH || "");
          formik.setFieldValue("ifsc_code", data.IFSC);
          
          // Hide manual fields since we found the bank
          setShowManualFields(false);
          
          // Clear any previous errors
          formik.setFieldError("ifsc_code", "");
          formik.setFieldError("bank_name", "");
          formik.setFieldError("branch_name", "");
          
          // Add to recent IFSCs (local storage for persistence)
          const newRecent = [
            { 
              ifsc: data.IFSC, 
              bank: data.BANK, 
              branch: data.BRANCH || "Main Branch", 
              city: data.CITY || data.CENTRE || data.ADDRESS || 'N/A',
              verified: true 
            },
            ...recentIFSCs.filter(item => item.ifsc !== data.IFSC)
          ].slice(0, 5); // Keep only last 5
          
          setRecentIFSCs(newRecent);
          localStorage.setItem('recentIFSCs', JSON.stringify(newRecent));
          
          // Show success alert temporarily
          setTimeout(() => {
            setApiError("");
          }, 3000);
          
          return true;
        } else {
          throw new Error("Invalid response from API");
        }
      } else {
        // IFSC not found in Razorpay database
        const errorMessage = "IFSC code not found in Razorpay database. Please verify or enter bank details manually";
        formik.setFieldError("ifsc_code", errorMessage);
        setApiError(errorMessage);
        setShowManualFields(true);
        return false;
      }
    } catch (error) {
      console.error("Error fetching IFSC details:", error);
      const errorMessage = "Unable to verify IFSC. Please check your internet connection or enter bank details manually";
      formik.setFieldError("ifsc_code", errorMessage);
      setApiError(errorMessage);
      setShowManualFields(true);
      return false;
    } finally {
      if (!isAutoFetch) {
        setIsVerifyingIFSC(false);
      }
      setIsLoading(false);
    }
  };

  // ✅ DEBOUNCED IFSC VALIDATION (auto-fetch when user types full IFSC)
  const debouncedIFSCFetch = useCallback(
    debounce(async (ifscCode) => {
      if (ifscCode && ifscCode.length === 11 && /^[A-Z]{4}0[A-Z0-9]{6}$/.test(ifscCode)) {
        await fetchBankFromIFSC(ifscCode, true);
      }
    }, 800),
    []
  );

  // ✅ HANDLE IFSC INPUT CHANGE
  const handleIFSCChange = (e) => {
    const value = e.target.value.toUpperCase();
    formik.setFieldValue("ifsc_code", value);
    
    // Clear errors when user starts typing
    if (apiError) setApiError("");
    if (formik.errors.ifsc_code) formik.setFieldError("ifsc_code", "");
    
    // Auto-fetch when complete IFSC is entered
    debouncedIFSCFetch(value);
  };

  // ✅ MANUAL IFSC VERIFICATION BUTTON HANDLER
  const handleVerifyIFSC = async () => {
    if (formik.values.ifsc_code && formik.values.ifsc_code.length === 11) {
      await fetchBankFromIFSC(formik.values.ifsc_code, false);
    } else {
      formik.setFieldError("ifsc_code", "Please enter a valid 11-character IFSC code");
      ifscInputRef.current?.focus();
    }
  };

  // ✅ HANDLE MANUAL BANK ENTRY SELECTION
  const handleManualEntry = () => {
    setShowManualFields(true);
    formik.setFieldValue("bank_name", "");
    formik.setFieldValue("branch_name", "");
    formik.setFieldValue("ifsc_code", "");
    ifscInputRef.current?.focus();
  };

  // ✅ LOAD RECENT IFSCs FROM LOCAL STORAGE ON MOUNT
  useEffect(() => {
    const saved = localStorage.getItem('recentIFSCs');
    if (saved) {
      try {
        setRecentIFSCs(JSON.parse(saved));
      } catch (e) {
        console.error("Error parsing recent IFSCs:", e);
      }
    }
  }, []);

  const handleFileChange = (e, fieldName) => {
    const file = e.currentTarget.files[0] || null;
    formik.setFieldValue(fieldName, file);
    formik.setFieldTouched(fieldName, true);
  };

  const isButtonDisabled = formik.isSubmitting || isLoading;

  return (
    <Container maxWidth={false} sx={{ mt: 5, maxWidth: 800 }}>
      <Paper elevation={4} sx={{ p: 4, borderRadius: 3 }}>
        <Box component="form" onSubmit={formik.handleSubmit} noValidate>
          <Stack spacing={3}>
            
            {/* ✅ API ERROR ALERT */}
            <Collapse in={!!apiError}>
              <Alert 
                severity="error"
                action={
                  <IconButton
                    aria-label="close"
                    color="inherit"
                    size="small"
                    onClick={() => setApiError("")}
                  >
                    <CloseIcon fontSize="inherit" />
                  </IconButton>
                }
                sx={{ mb: 2 }}
              >
                {apiError}
              </Alert>
            </Collapse>

            {/* ✅ ACCOUNT HOLDER AND NUMBER */}
            <TwoFieldRow>
              <TextField
                label={t("refundBank.labels.accountHolderName")}
                name="holder_name"
                value={formik.values.holder_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.holder_name && Boolean(formik.errors.holder_name)}
                helperText={formik.touched.holder_name && formik.errors.holder_name}
                fullWidth
              />
              <TextField
                label={t("refundBank.labels.accountNo")}
                name="acc_no"
                value={formik.values.acc_no}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.acc_no && Boolean(formik.errors.acc_no)}
                helperText={formik.touched.acc_no && formik.errors.acc_no}
                fullWidth
              />
            </TwoFieldRow>

            {/* ✅ IFSC CODE INPUT WITH VERIFICATION */}
            <Box sx={{ mb: 3 }}>
              <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600, color: 'text.primary' }}>
                Enter IFSC Code (11 characters)
              </Typography>
              
              <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-start' }}>
                <TextField
                  inputRef={ifscInputRef}
                  label="IFSC Code"
                  name="ifsc_code"
                  value={formik.values.ifsc_code}
                  onChange={handleIFSCChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.ifsc_code && Boolean(formik.errors.ifsc_code)}
                  helperText={
                    formik.touched.ifsc_code && formik.errors.ifsc_code
                      ? formik.errors.ifsc_code
                      : "Enter 11-digit IFSC code (e.g., HDFC0001234)"
                  }
                  fullWidth
                  inputProps={{
                    maxLength: 11,
                    style: { 
                      textTransform: 'uppercase',
                      fontFamily: 'monospace',
                      fontSize: '16px',
                      letterSpacing: '1px'
                    }
                  }}
                  placeholder="e.g., SBIN0001234"
                  disabled={isLoading || isVerifyingIFSC}
                />
                
                <Button
                  variant="contained"
                  onClick={handleVerifyIFSC}
                  disabled={!formik.values.ifsc_code || formik.values.ifsc_code.length !== 11 || isLoading || isVerifyingIFSC}
                  startIcon={<SearchIcon />}
                  sx={{ 
                    minWidth: 180,
                    height: 56,
                    textTransform: 'none'
                  }}
                >
                  {isVerifyingIFSC ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : (
                    "Verify via Razorpay"
                  )}
                </Button>
              </Box>
              
              {/* ✅ RECENT IFSC SUGGESTIONS */}
              {recentIFSCs.length > 0 && !formik.values.bank_name && (
                <Box sx={{ mt: 2 }}>
                  <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
                    Recently used IFSCs:
                  </Typography>
                  <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                    {recentIFSCs.map((item) => (
                      <Button
                        key={item.ifsc}
                        size="small"
                        variant="outlined"
                        onClick={() => {
                          formik.setFieldValue("ifsc_code", item.ifsc);
                          fetchBankFromIFSC(item.ifsc, false);
                        }}
                        sx={{ 
                          textTransform: 'none',
                          fontSize: '0.75rem',
                          borderRadius: 2
                        }}
                        startIcon={<SearchIcon fontSize="small" />}
                      >
                        {item.ifsc}
                      </Button>
                    ))}
                  </Stack>
                </Box>
              )}
              
              {/* ✅ MANUAL ENTRY OPTION */}
              {!showManualFields && (
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    Can't find your IFSC or bank not listed?
                  </Typography>
                  <Button
                    variant="text"
                    size="small"
                    onClick={handleManualEntry}
                    sx={{ textTransform: 'none' }}
                  >
                    + Enter bank details manually
                  </Button>
                </Box>
              )}
            </Box>

            {/* ✅ BANK DETAILS DISPLAY (AUTO-FILLED FROM IFSC) */}
            {(formik.values.bank_name || showManualFields) && (
              <Box sx={{ 
                p: 3, 
                border: showManualFields ? "2px dashed #1976d2" : "1px solid #e0e0e0", 
                borderRadius: 2, 
                bgcolor: showManualFields ? "#f5f9ff" : "#fafafa",
                transition: 'all 0.3s ease'
              }}>
                {showManualFields ? (
                  <>
                    <Typography variant="subtitle1" color="primary.main" sx={{ mb: 2, fontWeight: 600 }}>
                      📝 Enter Bank Details Manually:
                    </Typography>
                    <TwoFieldRow>
                      <TextField
                        label="Bank Name *"
                        name="bank_name"
                        value={formik.values.bank_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.bank_name && Boolean(formik.errors.bank_name)}
                        helperText={formik.touched.bank_name && formik.errors.bank_name}
                        fullWidth
                        disabled={isLoading}
                      />
                      <TextField
                        label="Branch Name *"
                        name="branch_name"
                        value={formik.values.branch_name}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={formik.touched.branch_name && Boolean(formik.errors.branch_name)}
                        helperText={formik.touched.branch_name && formik.errors.branch_name}
                        fullWidth
                        disabled={isLoading}
                      />
                    </TwoFieldRow>
                  </>
                ) : (
                  <>
                    <Typography variant="subtitle1" color="success.main" sx={{ mb: 2, fontWeight: 600 }}>
                      ✓ Bank Details Verified via Razorpay API
                    </Typography>
                    <TwoFieldRow>
                      <TextField
                        label="Bank Name"
                        name="bank_name"
                        value={formik.values.bank_name}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        variant="filled"
                      />
                      <TextField
                        label="Branch Name"
                        name="branch_name"
                        value={formik.values.branch_name}
                        InputProps={{
                          readOnly: true,
                        }}
                        fullWidth
                        variant="filled"
                      />
                    </TwoFieldRow>
                    <TextField
                      label="IFSC Code"
                      name="ifsc_code"
                      value={formik.values.ifsc_code}
                      InputProps={{
                        readOnly: true,
                      }}
                      fullWidth
                      variant="filled"
                      sx={{ mt: 2 }}
                    />
                    
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <Button
                        size="small"
                        variant="outlined"
                        onClick={handleManualEntry}
                        sx={{ textTransform: 'none' }}
                      >
                        Need to edit? Enter manually
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            )}

            {/* ✅ IFSC LOOKUP HELP LINK */}
            {!formik.values.bank_name && !showManualFields && (
              <Alert severity="info" sx={{ mb: 2 }}>
                <Typography variant="body2">
                  Need help finding your IFSC code? Visit the official{" "}
                  <a 
                    href="https://ifsc.razorpay.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{ color: '#1976d2', fontWeight: 'bold', textDecoration: 'none' }}
                  >
                    Razorpay IFSC Finder
                  </a>
                  {" "}to search by bank and branch.
                </Typography>
              </Alert>
            )}

            {/* ✅ FILE UPLOAD */}
            <Box sx={{ display: "flex", flexDirection: "column", mb: 2 }}>
              <UploadWithLabel
                label={t("refundBank.labels.uploadPassbook")}
                name="refund_front_sheet"
                onChange={(e) => handleFileChange(e, "refund_front_sheet")}
                file={formik.values.refund_front_sheet}
                error={formik.touched.refund_front_sheet && Boolean(formik.errors.refund_front_sheet)}
                helperText={formik.touched.refund_front_sheet && formik.errors.refund_front_sheet}
                disabled={isLoading}
              />
              {formik.touched.refund_front_sheet && formik.errors.refund_front_sheet && !formik.values.refund_front_sheet && (
                <Typography color="error" variant="caption" sx={{ ml: 2 }}>
                  {formik.errors.refund_front_sheet}
                </Typography>
              )}
            </Box>

            {/* ✅ NAVIGATION BUTTONS */}
            <Box sx={{ display: "flex", justifyContent: "space-between", mt: 3 }}>
              <Button 
                variant="outlined" 
                onClick={() => activeTab > 0 && setActiveTab(activeTab - 1)}
                disabled={isLoading}
              >
                {t("refundBank.buttons.back")}
              </Button>
              <Button 
                type="submit" 
                variant="contained"
                disabled={isButtonDisabled}
                sx={{
                  minWidth: 120,
                  "&.Mui-disabled": {
                    backgroundColor: "rgba(25, 118, 210, 0.6)",
                    color: "rgba(255, 255, 255, 0.9)",
                    cursor: "not-allowed",
                  },
                }}
              >
                {isLoading ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  t("refundBank.buttons.next")
                )}
              </Button>
            </Box>
            
            {/* ✅ API STATUS INDICATOR */}
            {isLoading && (
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mt: 2 }}>
                <CircularProgress size={20} sx={{ mr: 1 }} />
                <Typography variant="caption" color="text.secondary">
                  Connecting to Razorpay IFSC API...
                </Typography>
              </Box>
            )}
          </Stack>
        </Box>
      </Paper>
    </Container>
  );
}

export default RefundBankSection;